export default "__VITE_ASSET__Diqs9Cfz__"